// import React from "react";
// import { useParams } from "react-router-dom";

// const StateDetails = () => {
//   const { stateName } = useParams();

//   return (
//     <div style={{ padding: "40px" }}>
//       <h1>{stateName}</h1>
//       <p>
//         Showing properties for <strong>{stateName}</strong>
//       </p>
//     </div>
//   );
// };

// export default StateDetails;


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./StateDetails.css";

const StateDetails = () => {
  const { stateName } = useParams(); // city name
  const [allProperties, setAllProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);

  useEffect(() => {
    fetchProperties();
  }, []);

  useEffect(() => {
    filterByCity();
  }, [stateName, allProperties]);

  const fetchProperties = async () => {
    try {
      const res = await axios.get("https://api.propertygalleria.in/get/properties");
      setAllProperties(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const filterByCity = () => {
    const filtered = allProperties.filter(
      (item) =>
        item.city &&
        item.city.toLowerCase() === stateName.toLowerCase()
    );
    setFilteredProperties(filtered);
  };

  return (
    <div className="container">
      <h2 className="title">
        Properties for Sale in {stateName}
      </h2>

      <div className="grid">
        {filteredProperties.map((item) => (
          <div className="card" key={item.id}>
            <img src={item.image} alt={item.property_name} />

            <div className="card-body">
              <h3>{item.property_name}</h3>
              <p className="location">
                {item.location || item.city}
              </p>

              <div className="tags">
                <span>Residential</span>
              </div>
            </div>
          </div>
        ))}

        {filteredProperties.length === 0 && (
          <p>No properties found for this city</p>
        )}
      </div>
    </div>
  );
};

export default StateDetails;
